import type { Params } from "../toQueryString";
import { absolutePath } from "./absolutePath";

export const site = {
  pages: {
    show: (id: number) => absolutePath(`site/pages/${id}`),

    passwordAttempt: {
      create: ({ pageId }: { pageId: number }) =>
        absolutePath(`site/pages/${pageId}/password_attempt`),
    },
  },
  dynamicContent: {
    newsletterPosts: {
      index: ({ params = {} }: { params?: Params } = {}) =>
        absolutePath("site/dynamic_content/newsletter_posts", params),
    },
  },
};
